import * as React from 'react';
import { Button } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from '../../store';
import { choiceActionCreators } from '../../store/Choice';
import { trainingActionCreators } from '../../store/Training';
import { ChoiceValue, CardOption } from '../../types/TrainingTypes';
import ChoiceOptions from './ChoiceOptions';

export default function Choice() {
    const trainingState = useAppSelector(state => state.training);
    const state = useAppSelector(state => state.choice);
    const dispatch = useAppDispatch();
    const [isTimerActive, setIsTimerActive] = React.useState(false);

    let borderColor = undefined;
    const reviews = trainingState.card?.resultInfo?.reviews;
    if (reviews && reviews >= 700)
        borderColor = '#001dda';
    else if (reviews && reviews >= 600)
        borderColor = '#4400da';
    else if (reviews && reviews >= 500)
        borderColor = '#9e00da';
    else if (reviews && reviews >= 400)
        borderColor = '#da0092';
    else if (reviews && reviews >= 300)
        borderColor = '#da0000';
    else if (reviews && reviews >= 200)
        borderColor = '#da6400'
    else if (reviews && reviews >= 100)
        borderColor = '#c5a900';

    function nextCard() {
        dispatch(trainingActionCreators.nextCard());
    }

    function chooseOption(option: CardOption | undefined, isLong: boolean) {
        if (!isTimerActive) {
            const isCorrect = option?.content === state.solution;
            if (trainingState.isSolutionShown) {
                if (option?.content === state.solution || !trainingState.isServicePanelEnabled)
                    nextCard();
            }
            else {
                if (isCorrect && !trainingState.isServicePanelEnabled) {
                    setIsTimerActive(true);
                    setTimeout(() => {
                        setIsTimerActive(false);
                        nextCard();
                    }, 500);
                }
                dispatch(choiceActionCreators.chooseOption(option));

                const assessmentValue = isCorrect
                    ? isLong
                        ? ChoiceValue.Know
                        : ChoiceValue.Correct
                    : isLong
                        ? ChoiceValue.Decrease
                        : ChoiceValue.Incorrect;
                const time = new Date().getTime() - new Date(state.shownTime!).getTime();

                let difficulty = Math.min(20, (6 + state.task.length));
                let correctOptionPassed = false;
                for (let i = 0; i < state.options.length; i++) {
                    difficulty += (Math.min(20, (6 + state.options[i].content.length)) * (correctOptionPassed ? 0.6 : 1));
                    correctOptionPassed ||= (state.options[i].content === option?.content);
                }
                dispatch(trainingActionCreators.choiceAssess(assessmentValue, time, Math.round(difficulty)));
            }
        }
    }

    function resetTimer() {
        dispatch(choiceActionCreators.resetTimer());
    }

    function showExample() {
        dispatch(choiceActionCreators.showExample());
    }

    return (
        <div className="flex-grow-1 w-100 width-limit text-break">
            <div style={{ minHeight: '6.5rem' }}>
                <div className="training-box task mb-2"
                    style={{ borderColor: borderColor }}
                    onDoubleClick={resetTimer}>
                    <div>
                        <span className="task">{state.task}</span>
                        {state.taskAux &&
                            <>
                                <br />
                                <span className="text-secondary"> {state.taskAux}</span>
                            </>
                        }
                    </div>
                </div>
            </div>

            <ChoiceOptions options={state.options}
                backgrounds={state.backgrounds}
                chooseOption={chooseOption} />

            {state.example &&
                <>
                    {state.isExampleShown || ((trainingState.isServicePanelEnabled || state.chosenOption?.content !== state.solution) && trainingState.isSolutionShown) ?
                        <div className="training-box mt-3">
                            <div className="example">
                                <span style={{ whiteSpace: 'pre-wrap' }}>{state.example}</span>
                            </div>
                        </div>
                        :
                        <div className="row g-2 g-sm-3 my-2">
                            <div className="col-12 col-sm-6 mx-sm-auto">
                                <Button variant="outline-secondary"
                                    size="lg"
                                    className={state.backgrounds[4] ?? ''}
                                    onClick={() => showExample()}>
                                    Show example
                                </Button>
                            </div>
                        </div>
                    }
                </>
            }

            {state.wrongOption &&
                <div className="fs-5 mt-2"><span className="red">{state.wrongOption.content}</span> - <span className="fw-bold">{state.wrongOption.wrongOption}</span></div>
            }
        </div>
    );
}
